import {
    setStorage,
    getStorage,
} from '@/libs/utils'
import { appLaunch} from '@/libs/api'
import config from '@/config'
export default {
    state: {
        appInfo: '',
        showSpin: false
    },
    getters: {
        getAppInfo: state => {
            var appinfo = {}
            if (state.appInfo) {
                appinfo = state.appInfo
            } else {
                appinfo = getStorage('appInfo');
                if (!appinfo || appinfo.length==0) {
                    appinfo = config.commonappInfo;
                }
            }
            return Object.assign(appinfo, { appid: 11 });
        }
    },
    mutations: {
        setAppInfo(state, appInfo) {
            state.appInfo = appInfo
        },
        handleSpinShow(state, value) {
            if (!value) {
                setTimeout(() => {
                    state.showSpin = value
                }, 500)
            } else {
                state.showSpin = value

            }

        }
    },
    actions: {
        handleAppInfo({ commit }, info) {
            var appinfo = setStorage('appInfo', info);
            commit('setAppInfo', appinfo);
        },
        getLaunchInfo({ commit }) {
            return new Promise((resolve, reject) => {
                try {
                    appLaunch().then((res) => {
                        if (res.status * 1 == 200) {
                            commit('setAppInfo', res.data);
                            setStorage('appInfo', res.data, true);
                        }
                        resolve(res);
                    })
                } catch (error) {
                    reject(error);
                }
            });


        }
    }
}
